import { render, staticRenderFns } from "./reallocatepallet.vue?vue&type=template&id=91c3fa4a"
import script from "./reallocatepallet.vue?vue&type=script&lang=js"
export * from "./reallocatepallet.vue?vue&type=script&lang=js"
import style0 from "./reallocatepallet.vue?vue&type=style&index=0&id=91c3fa4a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports